import React, { useContext, useState } from 'react';
import { Trans } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import Notification, { NotificationDuration, } from '../../Notifications/Notification';
import SystemNotification from '../../SystemNotification';
import { ResourceType } from '../../types/resource';
import { scrollIntoViewInViewportBottom } from '../../utils/scrollIntoViewWithHeader';
import BadgeNotificationIcon from './BadgeNotificationIcon';
import s from './BadgeNotification.scss';
var BadgeNotification = function (_a) {
    var id = _a.id, queueName = _a.queueName, badge = _a.badge, recipient = _a.recipient, removeNotification = _a.removeNotification;
    var isMobile = useContext(MobileContext);
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var transKey;
    switch (recipient.typeId) {
        case ResourceType.DEVIATION:
            transKey = 'coreBadge.awardBadge.success.tooltip.deviation';
            break;
        case ResourceType.COMMENT:
            transKey = 'coreBadge.awardBadge.success.tooltip.comment';
            break;
        default:
            return null;
    }
    return (React.createElement(Notification, { id: id, queueName: queueName, cardComponent: SystemNotification, onOpen: function (notificationId, el) {
            if (!isOpen && recipient.typeId === ResourceType.DEVIATION) {
                // Scroll so that the badge itself is also in view
                setIsOpen(true);
                el && scrollIntoViewInViewportBottom(el, isMobile, 60, undefined);
            }
        }, onClose: function () {
            setIsOpen(false);
            removeNotification(id);
        }, cardProps: {
            multiLine: true,
            duration: NotificationDuration.M,
            withCloseButton: !isMobile,
            closeButtonClassName: s['close-button'],
            className: s['root'],
            customIcon: (React.createElement(BadgeNotificationIcon, { name: badge.name, imgSrc: badge.images[0].imageUrl })),
        } },
        React.createElement("div", { className: s['badge-text'] }, 
        /* prettier-ignore */
        React.createElement(Trans, { i18nKey: transKey },
            "You've awarded a ",
            React.createElement("strong", null, {
                title: badge.baseTitle
            }),
            " to this item!"))));
};
BadgeNotification.displayName = 'BadgeNotification';
export default BadgeNotification;
//# sourceMappingURL=BadgeNotification.js.map